import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ApiErrorState = {
  isApiError: boolean;
  apiErrorStatus: number | null;
};

const initialState: ApiErrorState = {
  // API エラーをハンドリングするためのフラグです。
  isApiError: false,

  // API エラーのステータスコードを格納します。
  apiErrorStatus: null,
};

const apiErrorSlice = createSlice({
  name: "apiError",
  initialState,
  reducers: {
    apiError: (state, action: PayloadAction<number>) => {
      state.isApiError = true;
      state.apiErrorStatus = action.payload;
    },
    apiErrorHandled: (state) => {
      state.isApiError = false;
      state.apiErrorStatus = null;
    },
  },
});

export const { apiError, apiErrorHandled } = apiErrorSlice.actions;
export default apiErrorSlice.reducer;
